import { Flex } from "@chakra-ui/react";
import { PromptbookEditorHeaderSkeleton } from "./PromptbookEditorHeaderSkeleton";

export const PromptbookEditorPageSkeleton = () => {
  return (
    <Flex width="100%" flex="1" direction="column" height="100%" overflow="hidden">
      <PromptbookEditorHeaderSkeleton />
      <Flex height="100%"></Flex>
    </Flex>
  );
};
